import React from 'react'
import { CertIndividualComp } from '../../../../components/CertIndividualComp/CertIndividualComp'


const CertComponents = () => {
  const IntList = [ { Interest: "UX Designer" , date: "Sept '25 - Current",  company: "Indiana University",location:"Bloomington, Indiana", color: 'var(--coral-400)' },
  { Interest: "Data Specialist", date: " Aug '24- Jan '26", company: "Indiana Geologic and Water Survey", location:"Bloomington, IN", color: 'var(--blue-400)' },
  { Interest: "Information Systems Designer", date: "July '19 - Aug '25",  company: "Buffalouie's LLC", location:"Bloomington, IN", color: 'var(--green-400)' }, 
  { Interest: "Informatics BS", date: "Aug '24 - May '27", company: "Indiana Univerity", location:"Bloomington, IN", color:'var(--yellow-400)'  },
  { Interest: "Retail Leadership & Technical Support Leadership Roles ", date: " Jan '20 - July '24",  company: "T-Mobile USA", location:"Multiple Locations", color: 'var(--pink-400)'},
  
  ] 
  
  return (
    <div >
      <ul>
        <div className='CertsDisplayed'>
          <ul>
            {IntList.map(subject => {

              return (
                <div className='certs' ><CertIndividualComp InterestTitle={subject.Interest} InterestDates={subject.date} InterestLocation={subject.location} JobCompany={subject.company}InterestBorderColor={subject.color}></CertIndividualComp>
                </div>
              )
            })}
          </ul>


        </div>
      </ul>
    </div>
  )
}

export default CertComponents